import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

export default class Payment {
  constructor(token) {
    axios.defaults.baseURL = API_URL + '/v1/payments/'
    axios.defaults.headers.common['Authorization'] = `Bearer ${token.token}`
  }

  getQrCode(external_id) {
    return axios.get(`/invoice/${external_id}/qrcode`)
  }

  addInvoice(data) {
    return axios.post('/invoice', data)
  }

  checkPayment(id) {
    return axios.get(`/invoice/${id}/payment?source=wallet`)
  }
}
